import { SEL_CURRENT_LEVEL_CONFIG } from '../../b.providers/ScenesProvider/selectors'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import { COMMANDERS } from '../../c.managers/LevelManager/store.d'
import SPELLS, { SpellConfig } from '../../e.elements/GameElements/classes/Spells'
import BaseWindow from './components/BaseWindow/BaseWindow'
import SpellCard from './components/SpellCard/SpellCard'
import { NavContextType, useNav } from './ScreensNav'
import { Spell } from '../../c.managers/LevelManager/store.d'

const LevelNext = ({ ctx }: { ctx: NavContextType }) => {
  const { dismiss } = ctx
  const levelInfo = useScenesStore(SEL_CURRENT_LEVEL_CONFIG)
  const num = Number(levelInfo.id.replace('level', ''))
  const show = true
  return (
    <>
      <BaseWindow show={show}>
        <div className={`body-container team-selection-container`}>
          <div className="header-container">
            <span>Level {num}/5</span>
          </div>
          <div className="body-content">
            <div className="body-row">
              <span>Next Cemetery</span>
            </div>

            <div
              className="body-row"
              style={{
                backgroundImage: `url("${process.env.PUBLIC_URL}/assets/images/graveyard.svg")`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                height: '33%',
              }}
            >
              <span className="level-title">{levelInfo.name}</span>
            </div>
            <div className="body-row">
              <span>Available Spells</span>
            </div>
            <div className="body-row" style={{ borderBottom: '2px solid #430064AA' }}>
              <SpellsSlider list={levelInfo.players.find(p => p.id === COMMANDERS.PLAYER)?.spells as Spell[]} />
            </div>
            <div className="body-row">
              <a className="theme-button button-orange-big" onClick={() => dismiss()}>
                ENTER
              </a>
            </div>
          </div>
        </div>
      </BaseWindow>
    </>
  )
}

export default LevelNext

const SpellsSlider = ({ list }: { list: Spell[] }) => {
  // const spells = list
  const spells = list.reduce((res: Record<string, Spell & { count: number }>, sp: Spell) => {
    if (!res[sp.name]) {
      res[sp.name] = { ...sp, count: 0 }
    }
    res[sp.name].count++
    return res
  }, {})

  return (
    <div className="slider">
      <div className="slides">
        {Object.values(spells).map((s: any & { count: number }, idx) => (
          <div key={`slide-${idx + 1}`} id={`slide-${idx + 1}`}>
            <div data-ico={s.icon} className="spell-card-text" style={{ marginTop: 15 }}>
              {s.name}
            </div>
            <div className="spell-card-text" style={{}}>
              x{s.count}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
